import React, { useState, useEffect } from "react";
import Fade from "react-reveal/Fade";
import Slide from "react-reveal/Slide";

import Logo from "../../assets/logo.png";
import CV from "../../assets/CV Giovanni Cuozzo.pdf";

import "./Navbar.scss";

var links = [
  {
    name: "About",
    link: "#about",
  },
  {
    name: "Experience",
    link: "#jobs",
  },
  {
    name: "Work",
    link: "#projects",
  },
  {
    name: "Contact",
    link: "#contact",
  },
];

const Navbar = () => {
  const [show, setShow] = useState(true);
  const [open, setOpen] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  const controlNavbar = () => {
    if (typeof window !== "undefined") {
      if (window.scrollY < lastScrollY) {
        setShow(false);
      } else {
        setShow(true);
      }

      setLastScrollY(window.scrollY);
    }
  };

  const closeNav = () => {
    setOpen(false);
    document.body.style.overflow = "initial";
    document.querySelector("#content").classList.remove("blind");
  };

  useEffect(() => {
    if (window.scrollY === 0) setShow(false);

    if (typeof window !== "undefined") {
      window.addEventListener("scroll", controlNavbar);
      return () => {
        window.removeEventListener("scroll", controlNavbar);
      };
    }
  }, [lastScrollY]);

  const [isMount, setIsMount] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsMount(true);
    }, 200);
  }, []);

  return (
    <nav className={`${show && "hidden"}`}>
      <Slide top cascade>
        <img src={Logo} alt="Logo" />
        <ol className={`links ${open && "open"}`}>
          {links.map((link, i) => (
            <li
              key={i}
              className=""
              style={{ transitionDelay: `${isMount ? i * 100 : 0}ms` }}
            >
              <Fade top>
                <a className="link" href={link.link} onClick={closeNav}>
                  {link.name}
                </a>
              </Fade>
            </li>
          ))}
          <li className="">
            <a className="btn" href={CV} download="CV - Giovanni Cuozzo">
              Resume
            </a>
          </li>
        </ol>
        <div
          className="hamburger"
          onClick={() => {
            setOpen(!open);
            document.body.style.overflow = !open ? "hidden" : null;
            if (!open)
              document.querySelector("#content").classList.add("blind");
            else document.querySelector("#content").classList.remove("blind");
          }}
        >
          <div
            className={!open ? "hamburger_inner" : "hamburger_inner open"}
          ></div>
        </div>
      </Slide>
    </nav>
  );
};

export default Navbar;
